/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Merge_LabelInputs */

const en_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Events`)
};

const fr_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner les evenements`)
};

const de_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführungsereignisse`)
};

const it_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci eventi`)
};

const ru_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние событий`)
};

const es_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar eventos`)
};

const zh_cn2_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并事件`)
};

const ja_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをマージする`)
};

const hi_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय घटनाएँ`)
};

const pt_pt2_context_menu_merge_label = /** @type {(inputs: Context_Menu_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar eventos`)
};

/**
* | output |
* | --- |
* | "Merge Events" |
*
* @param {Context_Menu_Merge_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_merge_label = /** @type {((inputs?: Context_Menu_Merge_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Merge_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_merge_label(inputs)
	if (locale === "de") return de_context_menu_merge_label(inputs)
	if (locale === "it") return it_context_menu_merge_label(inputs)
	if (locale === "ru") return ru_context_menu_merge_label(inputs)
	if (locale === "es") return es_context_menu_merge_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_merge_label(inputs)
	if (locale === "ja") return ja_context_menu_merge_label(inputs)
	if (locale === "hi") return hi_context_menu_merge_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_merge_label(inputs)
	return en_context_menu_merge_label(inputs)
});